import { gql } from '@apollo/client';
import { WarehouseType } from '../types/WarehouseType';

export interface CurrentUserOperableWarehousesResponse {
    warehouses: Array<Omit<WarehouseType, 'id' | 'parentSiteId'> & {
        id: string;
        parentSiteId: string;
        name: string;
        siteType: number;
        addressLine1: string;
        sortingCode: string | null;
        businessType: number;
        timezoneLocation: string | null;
    }>;
}

export const CURRENT_USER_OPERABLE_WAREHOUSES = gql`
  query CurrentUserOperableWarehouses {
    warehouses: currentUserOperableWarehouses {
      id
      parentSiteId
      name
      siteType
      addressLine1
      sortingCode
      businessType
      timezoneLocation
    }
  }
`;
